<div class="background-grid" [ngClass]="{ isSmallDevice: rwdService.isSmallDevice }">
  <div class="container-left">
    <div class="content-wrapper" *ngIf="!showBreakText">
      <div class="login-header">
        <div class="logo" [ngClass]="{ portrait: rwdService.isPhonePortrait }">
          <app-logo-svg color="primary"></app-logo-svg>
        </div>
      </div>

      <form [formGroup]="form">
        <div class="welcome-header">
          <h2 class="welcome-message">{{ welcomeMsgKey | loc }}</h2>
          <app-language-select></app-language-select>
        </div>
        <ng-container [ngSwitch]="currentStep">
          <!-- Step 1: Email Input -->
          <ng-container *appMultiCase="[LoginStep.EMAIL, LoginStep.CHECKING]">
            <app-text-input
              class="full-width"
              [labelKey]="'label.email' | toLL: 'capitalize'"
              type="email"
              formControlName="email"
              [outsideLabel]="false"
              [readonly]="currentStep === LoginStep.CHECKING"
            ></app-text-input>
            <button
              class="full-width"
              mat-flat-button
              color="primary"
              (click)="checkEmailDomain()"
              [disabled]="isCheckingDomain || form.get('email')?.invalid"
              *ngIf="currentStep === LoginStep.EMAIL"
            >
              {{ 'login.continue' | loc }}
            </button>
            <div class="loader-container" *ngIf="currentStep === LoginStep.CHECKING">
              <app-loader></app-loader>
            </div>
          </ng-container>

          <!-- Step 2a: Password Login (Traditional) -->
          <ng-container *ngSwitchCase="LoginStep.PASSWORD">
            <app-password-input class="full-width" labelKey="passwd.label" formControlName="password"></app-password-input>

            <div class="forgot-passwd">
              <a class="mat-primary mat-caption" (click)="resetPassword()">{{ 'passwd.forgot' | loc }}</a>
            </div>

            <div class="captcha-box full-width" *ngIf="isCaptchaRequired">
              <p class="mat-caption no-margin margin-bottom-10">{{ 'login.captchaInfo' | loc }}</p>
            </div>

            <button
              class="full-width"
              mat-flat-button
              color="primary"
              (click)="submitPasswordLogin()"
              [disabled]="form.get('email')?.invalid"
            >
              {{ 'login.button' | loc }}
            </button>
            <button class="full-width" mat-stroked-button color="primary" (click)="backToEmail()">
              {{ 'login.changeEmail' | loc }}
            </button>
          </ng-container>

          <!-- Step 2b: SSO Login -->
          <ng-container *ngSwitchCase="LoginStep.SSO">
            <div class="info-box">
              <p class="mat-body-1">{{ 'login.ssoDetected' | loc }}</p>
              <p class="mat-caption">{{ 'login.ssoDescription' | locRep: { $provider: getSsoProviderName() } }}</p>
            </div>

            <button
              class="full-width"
              mat-flat-button
              color="primary"
              [disabled]="isSubmittingSso"
              (click)="loginWithMicrosoft()"
            >
              <mat-icon *ngIf="!isSubmittingSso">business</mat-icon>
              <mat-spinner *ngIf="isSubmittingSso" diameter="20"></mat-spinner>
              {{ 'login.signInWith' | locRep: { $provider: getSsoProviderName() } }}
            </button>
          </ng-container>

          <!-- Step 3: SSO Pending Approval -->
          <ng-container *appMultiCase="[LoginStep.SSO_PENDING, LoginStep.SSO_REQUEST_SENT]">
            <app-access-pending
              [email]="pendingSsoEmail"
              [ssoConfig]="ssoConfig"
              (onRequest)="onRequestSent()"
              (onCancel)="backToEmail()"
            ></app-access-pending>
          </ng-container>
        </ng-container>
      </form>

      <ng-template *ngIf="rwdService.isSmallDevice" [ngTemplateOutlet]="footer"></ng-template>
    </div>
    <div *ngIf="showBreakText" class="break-wrapper">
      <h1>{{ 'break.header' | loc }}</h1>
      <div>
        {{ 'break.time' | loc }}
        <b> {{ breakData?.endDate | lDate: 'dtShort' }}</b>
      </div>
      <div class="padding-top-10">{{ 'break.text1' | loc }}.</div>
      <div class="padding-top-15 font-16">{{ 'break.text2' | loc }}.</div>
    </div>
  </div>
  <div class="container-right" *ngIf="!rwdService.isSmallDevice">
    <h1>{{ 'login.welcomeMessage' | loc }}</h1>
    <ng-template [ngTemplateOutlet]="footer"></ng-template>
  </div>
</div>

<ng-template #footer>
  <div class="login-links">
    <span
      >{{ 'login.techSupport' | loc }}: <a href="mailto:tehcsupport@fliko.pl">{{ 'techsupport@fliko.pl' }}</a></span
    >
    <a href="https://www.fliko.pl" target="_blank">www.fliko.pl</a>
  </div>
</ng-template>
